<!-- 理货人员信息 -->
<template>
    <div>
        <div class="searchFlex">
            <el-form size="mini" ref="searchform" :model="searchform" label-width="100px" :inline="true" class="demo-form-inline">
                <el-form-item label="姓名" style="margin-bottom: 0px !important">
                    <el-input v-model="searchform.name" clearable placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="电话" style="margin-bottom: 0px !important">
                    <el-input v-model="searchform.phone" clearable placeholder="请输入电话"></el-input>
                </el-form-item>
                <el-form-item label="仓库" style="margin-bottom: 0px !important">
                    <el-select v-model="searchform.ckName" placeholder="请选择仓库" style="width: 100%;" clearable>
                        <el-option v-for="item in ckNameList" :key="item.name" :label="item.name" :value="item.name"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" style="margin-bottom: 0px !important">
                    <div class="toolbar">
                        <el-button type="primary" size="mini" @click="getListBy">查询</el-button>
                        <el-button type="success" size="mini" @click="addUser">新增</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div style="margin-right:10px;">
                <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar>
            </div>
        </div>
        <div style="height: calc(100vh - 171px);">
            <vxe-table height="100%" :data="userList" ref="tallyClerkTable" id="tallyClerkTable" size="mini" border stripe
                :column-config="{ resizable: true }" :custom-config="customConfig" :row-config="{ isCurrent: true /* 启用当前行高亮 */ }"
                highlight-current-row>
                <vxe-column type="seq" width="50" align="center"></vxe-column>
                <vxe-column field="userName" title="姓名" min-width="100"></vxe-column>
                <vxe-column field="phone" title="电话" min-width="120"></vxe-column>
                <vxe-column field="ckName" title="仓库" min-width="160" show-overflow sortable></vxe-column>
                <vxe-column field="isForklift" title="是否叉车" min-width="160" show-overflow>
                    <template v-slot="{ row }">
                        <span v-if="row.isForklift === 1">是</span>
                        <span v-else>否</span>
                    </template>
                </vxe-column>
                <vxe-column field="isTally" title="是否理货" min-width="160" show-overflow>
                    <template v-slot="{ row }">
                        <span v-if="row.isTally === 1">是</span>
                        <span v-else>否</span>
                    </template>
                </vxe-column>
                <vxe-column field="openId" title="openId" min-width="120"></vxe-column>
                <vxe-column title="操作" width="100" align="center" fixed="right">
                    <template #default="{ row }">
                        <vxe-button mode="text" status="danger" icon="vxe-icon-delete" size="mini"
                            @click="deleteRow(row)">删除</vxe-button>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="getList" size="mini">
        </vxe-pager>
        <!-- 新增理货人员弹出框 -->
        <el-dialog title="新增理货人员" width="30%" :visible.sync="addUserVisible" :before-close="addUserClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-form ref="addUserForm" :model="addUserForm" label-width="80px" size="mini" :rules="rules">
                <el-form-item label="姓名" prop="userName">
                    <el-input v-model="addUserForm.userName" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="phone">
                    <el-input v-model="addUserForm.phone" placeholder="请输入电话"></el-input>
                </el-form-item>
                <el-form-item label="仓库" prop="ckName">
                    <el-select v-model="addUserForm.ckName" placeholder="请选择仓库" style="width: 100%;" clearable>
                        <el-option v-for="item in ckNameList" :key="item.name" :label="item.name" :value="item.name"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="岗位" prop="isTally">
                    <el-checkbox v-model="addUserForm.isTally" :true-label="1" :false-label="0">理货员</el-checkbox>
                    <el-checkbox v-model="addUserForm.isForklift" :true-label="1" :false-label="0">叉车工</el-checkbox>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="addUserClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveAddUser('addUserForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'tallyClerk',
    mixins: [userProfile],
    data() {
        return {
            userList: [], // 理货人员列表
            searchform: {
                name: '', // 姓名
                phone: '', // 电话
                ckName:'', // 仓库
            }, // 搜索条件
            // 分页信息
            pagination: {
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 10, // 每页显示多少条数据
            },
            pageSizes: [10, 15, 20, 50, 100],
            addUserVisible: false, // 新增理货人员弹窗是否显示
            addUserForm: {
                userName: '',
                phone: '',
                ckName: '',
                isTally: 1, // 是否理货：1是 0否
                isForklift: 1, // 是否叉车：1是 0否
            }, // 新增理货人员数据
            ckNameList: [], // 仓库列表
            rules: {
                userName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                ],
                ckName: [
                    { required: true, message: '请选择仓库', trigger: 'change' },
                ],
                // 岗位：理货员、叉车工至少选择一个，也可两个都选
                isTally: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.addUserForm.isTally === 1 || this.addUserForm.isForklift === 1) {
                                callback()
                            } else {
                                callback(new Error('理货员和叉车工至少选择一个'))
                            }
                        },
                        trigger: 'change'
                    }
                ],
            },
        }
    },
    //组件创建
    created() {
        this.getListBy()
        this.getCkNameList()
    },
    methods: {
        // 点击搜索查询
        getListBy() {
            this.pagination.currentPage = 1
            this.getList()
        },
        // 查询列表（翻页也走这里）
        getList() {
            const params = {
                userName: this.searchform.name,
                phone: this.searchform.phone,
                ckName: this.searchform.ckName,
            }
            this.$api.wmsMobileGetUserList(this.pagination.currentPage, this.pagination.pageSize, params).then(res => {
                const data = res || {}
                // 兼容 MyBatis-Plus 分页（records）与 { tableData, total } 两种返回
                this.userList = Array.isArray(data) ? data : data.records || data.tableData || []
                this.pagination.total = data.total || this.userList.length
            })
        },
        // 获取仓库
        getCkNameList() {
            this.$api.getInfo( ).then(res => {
                this.ckNameList = res
            })
        },
        // 打开新增弹窗
        addUser() {
            this.addUserVisible = true
        },
        // 关闭新增弹窗
        addUserClose() {
            this.addUserVisible = false
            this.$nextTick(() => {
                this.$refs.addUserForm.resetFields();
            })
            this.addUserForm = {
                userName: '',
                phone: '',
                ckName: '',
                isTally: 1, // 默认选中理货员
                isForklift: 1, // 默认选中叉车工
            }
        },
        // 新增理货人员
        saveAddUser(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        userName: this.addUserForm.userName,
                        phone: this.addUserForm.phone,
                        ckName: this.addUserForm.ckName,
                        isTally: this.addUserForm.isTally,
                        isForklift: this.addUserForm.isForklift,
                    }
                    this.$api.wmsMobileAddUser( params ).then(res => {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.addUserClose()
                        // 清掉查询条件重新查，避免新加的人被旧条件过滤掉看不到
                        this.searchform.name = ''
                        this.searchform.phone = ''
                        this.getListBy()
                    })
                }
            })
        },
        // 删除理货人员
        deleteRow(row) {
            this.$confirm('是否确认删除该理货人员?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmsMobileDeleteUser(row.id).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    // 删掉的是当前页最后一条时回到上一页，避免停在空页
                    if (this.userList.length === 1 && this.pagination.currentPage > 1) {
                        this.pagination.currentPage--
                    }
                    this.getList()
                })
            }).catch(() => {
            });
        },
    }
}
</script>
<style lang="css">
.searchFlex{
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items:center;
}
</style>
